const SLAOptions = {
  contractLevel: {
    title: 'Contract Level',
    options: [
      { label: 'PM+CM+EC+Replacement', value: 'PM+CM+EC+Replacement' },
      { label: 'PM+CM+Replacement', value: 'PM+CM+Replacement' },
      { label: 'PM+Replacement', value: 'PM+Replacement' },
      { label: 'Preventive & Emergency (PM+EC)', value: 'Preventive & Emergency (PM+EC)' },
      { label: 'Preventive Only (PM)', value: 'Preventive Only (PM)' },
      { label: 'Corrective Only (CM)', value: 'Corrective Only (CM)' },
      { label: 'Preventive & Corrective (PM+CM)', value: 'Preventive & Corrective (PM+CM)' },
      { label: 'Preventive & Corrective & Emergency PM+CM+EC', value: 'Preventive & Corrective & Emergency PM+CM+EC' },
    ],
  },
  serviceOfficeHours: {
    title: 'Service Office Hours',
    options: [
      { label: 'Mon-Fri, 9-6pm, Excl. Holidays', value: 'Mon-Fri, 9-6pm, Excl. Holidays' },
      { label: 'Mon-Fri,9-5:30pm, Sat, 9-1pm, Excl. Holidays', value: 'Mon-Fri,9-5:30pm, Sat, 9-1pm, Excl. Holidays' },
      { label: 'Mon-Fri,9-6pm, Sat, 9-1pm, Excl. Holidays', value: 'Mon-Fri,9-6pm, Sat, 9-1pm, Excl. Holidays' },
      { label: 'Mon-Fri,9-5:30pm, Excl.Sat & Holidays', value: 'Mon-Fri,9-5:30pm, Excl.Sat & Holidays' },
      { label: 'Mon-Sat, 8-6pm, Excl. Holidays', value: 'Mon-Sat, 8-6pm, Excl. Holidays' },
      { label: 'Mon-Sat, 9-5pm, Excl. Holidays', value: 'Mon-Sat, 9-5pm, Excl. Holidays' },
      { label: 'Mon-Sat, 9-6pm, Excl. Holidays', value: 'Mon-Sat, 9-6pm, Excl. Holidays' },
      { label: 'Mon-Sun, 9-6pm, Excl. Holidays', value: 'Mon-Sun, 9-6pm, Excl. Holidays' },
      { label: 'Mon-Sun, 9-6pm, including Holidays', value: 'Mon-Sun, 9-6pm, including Holidays' },
      { label: 'Mon-Friday 8:30-6:30pm', value: 'Mon-Friday 8:30-6:30pm' },
      { label: 'Sat 8:30-1:30pm, Excl. Holidays', value: 'Sat 8:30-1:30pm, Excl. Holidays' },
      { label: 'Mon-Friday 8:30-5:30pm', value: 'Mon-Friday 8:30-5:30pm' },
      { label: 'Sat 8:30-1:00pm, Excl. Holidays', value: 'Sat 8:30-1:00pm, Excl. Holidays' },
      { label: 'Sat, 9-6pm', value: 'Sat, 9-6pm' },
      { label: '24 hours a day, 7 days a week', value: '24 hours a day, 7 days a week' },
      { label: 'Everyday, 8-6pm', value: 'Everyday, 8-6pm' },
      { label: 'Everyday, 9-6pm', value: 'Everyday, 9-6pm' },
      { label: 'Mon-Fri, 9-5pm, Excl. Holidays', value: 'Mon-Fri, 9-5pm, Excl. Holidays' },
      { label: '24 hours a day, Mo - Sat', value: '24 hours a day, Mo - Sat' },
      { label: 'Mon-Sun, 8-6pm, including Holidays', value: 'Mon-Sun, 8-6pm, including Holidays' },
      { label: 'Mon-Sat, 8pm to 8am', value: 'Mon-Sat, 8pm to 8am' },
    ],
  },
  responseTime: {
    title: 'Response Time',
    options: [
      { label: 'Response time of 5 mins', value: 'Response time of 5 mins' },
      { label: 'Response time of 15 mins', value: 'Response time of 15 mins' },
      { label: 'Response time of 30 mins', value: 'Response time of 30 mins' },
      { label: 'Response time of 1 hour', value: 'Response time of 1 hour' },
      { label: 'Response time of 2 hour', value: 'Response time of 2 hour' },
      { label: 'Response time of 3 hour', value: 'Response time of 3 hour' },
      { label: 'Response time of 4 hour', value: 'Response time of 4 hour' },
      { label: 'Response time of 6 hour', value: 'Response time of 6 hour' },
      { label: 'Response time of 8 hour', value: 'Response time of 8 hour' },
      { label: '1 working day', value: '1 working day' },
      { label: 'At a reasonable promptness', value: 'At a reasonable promptness' },
      { label: 'n/a', value: 'n/a' },
    ],
  },
  onSiteArrivalTime: {
    title: 'On Site Arrival Time',
    options: [
      { label: 'Arrival Time in 1 hour', value: 'Arrival Time in 1 hour' },
      { label: 'Arrival Time in 2 hour', value: 'Arrival Time in 2 hour' },
      { label: 'Arrival Time in 3 hour', value: 'Arrival Time in 3 hour' },
      { label: 'Arrival Time in 4 hour', value: 'Arrival Time in 4 hour' },
      { label: 'Arrival Time in 24 hour', value: 'Arrival Time in 24 hour' },
      { label: 'Arrival Time in 48 hour', value: 'Arrival Time in 48 hour' },
      { label: 'Contact customer promptly', value: 'Contact customer promptly' },
      { label: 'n/a', value: 'n/a' },
    ],
  },
  emergencyService: {
    title: 'Emergency Service',
    options: [
      { label: 'Unlimited EC Service (7x24)', value: 'Unlimited EC Service (7x24)' },
      { label: 'Unlimited EC (Off. Hour only)', value: 'Unlimited EC (Off. Hour only)' },
      {
        label: 'Unlimited EC (Off. Hour only) & Limit 6 EC (non Off. Hour)',
        value: 'Unlimited EC (Off. Hour only) & Limit 6 EC (non Off. Hour)',
      },
      {
        label: 'Unlimited EC (Off. Hour only) & Limit 12 EC (non Off. Hour)',
        value: 'Unlimited EC (Off. Hour only) & Limit 12 EC (non Off. Hour)',
      },
      {
        label: 'Limit 4 EC (Off. Hour only) & Limit 2 EC (non Off. Hour)',
        value: 'Limit 4 EC (Off. Hour only) & Limit 2 EC (non Off. Hour)',
      },
      { label: 'Limit 2 EC (Contract period)', value: 'Limit 2 EC (Contract period)' },
      { label: 'Limit 45 EC (Contract period)', value: 'Limit 45 EC (Contract period)' },
      { label: 'Limit 3 EC (Contract period)', value: 'Limit 3 EC (Contract period)' },
      { label: 'Limit 4 EC (Contract period)', value: 'Limit 4 EC (Contract period)' },
      { label: 'Limit 5 EC (Contract period)', value: 'Limit 5 EC (Contract period)' },
      { label: 'Limit 6 EC (Contract period)', value: 'Limit 6 EC (Contract period)' },
      { label: 'Limit 7 EC (Contract period)', value: 'Limit 7 EC (Contract period)' },
      { label: 'Limit 8 EC (Contract period)', value: 'Limit 8 EC (Contract period)' },
      { label: 'Limit 12 EC (Contract period)', value: 'Limit 12 EC (Contract period)' },
      { label: 'Limit 15 EC (Contract period)', value: 'Limit 15 EC (Contract period)' },
      { label: 'Limit 20 EC (Contract period)', value: 'Limit 20 EC (Contract period)' },
      { label: 'Limit 24 EC (Contract period)', value: 'Limit 24 EC (Contract period)' },
      { label: 'Limit 60 EC (Contract period)', value: 'Limit 60 EC (Contract period)' },
      { label: 'Others (refer to remark)', value: 'Others (refer to remark)' },
      { label: 'Excluded', value: 'Excluded' },
      { label: 'Limit 1 EC (Contract period)(Off. Hour)', value: 'Limit 1 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 2 EC (Contract period)(Off. Hour)', value: 'Limit 2 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 3 EC (Contract period)(Off. Hour)', value: 'Limit 3 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 4 EC (Contract period)(Off. Hour)', value: 'Limit 4 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 5 EC (Contract period)(Off. Hour)', value: 'Limit 5 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 6 EC (Contract period)(Off. Hour)', value: 'Limit 6 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 10 EC (Contract period)(Off. Hour)', value: 'Limit 10 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 12 EC (Contract period)(Off. Hour)', value: 'Limit 12 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 14 EC (Contract period)(Off. Hour)', value: 'Limit 14 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 15 EC (Contract period)(Off. Hour)', value: 'Limit 15 EC (Contract period)(Off. Hour)' },
      { label: 'Limit 36 EC (Contract period)(Off. Hour)', value: 'Limit 36 EC (Contract period)(Off. Hour)' },
      {
        label: 'Unlimited EC (Off. Hour only) & Limit 24 EC (non Off. Hour)',
        value: 'Unlimited EC (Off. Hour only) & Limit 24 EC (non Off. Hour)',
      },
      {
        label: 'Unlimited EC (Off. Hour only) & Limit 108 EC (non Off. Hour)',
        value: 'Unlimited EC (Off. Hour only) & Limit 108 EC (non Off. Hour)',
      },
    ],
  },
  frequencyOfPMFieldPanelEquipment: {
    title: 'Frequency of PMField Panel Equipment',
    options: [
      { label: 'Annual Inspection', value: 'Annual Inspection' },
      { label: 'Half yearly Inspection', value: 'Half yearly Inspection' },
      { label: 'Quarterly Inspection', value: 'Quarterly Inspection' },
      { label: '4-Monthly Inspection', value: '4-Monthly Inspection' },
      { label: 'Monthly Inspection', value: 'Monthly Inspection' },
      { label: 'Weekly Inspection', value: 'Weekly Inspection' },
      { label: 'n/a', value: 'n/a' },
    ],
  },
  frequencyofPMServerWorkstation: {
    title: 'Frequency of PM Server Workstation',
    options: [
      { label: 'Annual Inspection', value: 'Annual Inspection' },
      { label: 'Half yearly Inspection', value: 'Half yearly Inspection' },
      { label: 'Quarterly Inspection', value: 'Quarterly Inspection' },
      { label: '4-Monthly Inspection', value: '4-Monthly Inspection' },
      { label: 'Monthly Inspection', value: 'Monthly Inspection' },
      { label: 'Bi Monthly Inspection', value: 'Bi Monthly Inspection' },
      { label: 'Weekly Inspection', value: 'Weekly Inspection' },
      { label: 'n/a', value: 'n/a' },
      { label: 'Weekly Inspection', value: 'Weekly Inspection' },
    ],
  },
  correctiveMaintenance: {
    title: 'Corrective Maintenance',
    options: [
      { label: 'Unlimited CM Service', value: 'Unlimited CM Service' },
      { label: 'Unlimited CM (Off. Hour only)', value: 'Unlimited CM (Off. Hour only)' },
      { label: 'Limit 1 CM (Contract period)', value: 'Limit 1 CM (Contract period)' },
      { label: 'Limit 4 CM (Contract period)', value: 'Limit 4 CM (Contract period)' },
      { label: 'Limit 12 CM (Contract period)', value: 'Limit 12 CM (Contract period)' },
      { label: 'Limit 24 CM (Contract period)', value: 'Limit 24 CM (Contract period)' },
      { label: 'Excluded', value: 'Excluded' },
    ],
  },
  sparePartsSupplyServices: {
    title: 'Spare Parts Supply Services',
    options: [
      { label: 'Provide Spare Parts in EQ List', value: 'Provide Spare Parts in EQ List' },
      { label: 'Provide Spare Parts -Excl. 3rd', value: 'Provide Spare Parts -Excl. 3rd' },
      { label: 'Provide Spare Parts -Excl. 3rd & obsolete', value: 'Provide Spare Parts -Excl. 3rd & obsolete' },
      { label: 'Excluded Spare Parts Supply', value: 'Excluded Spare Parts Supply' },
    ],
  },
  inclusion: {
    title: 'Inclusion',
    options: [
      { label: 'n/a', value: 'n/a' },
      { label: 'FS251 Certificate', value: 'FS251 Certificate' },
      { label: 'Transportation', value: 'Transportation' },
      { label: 'Consumables < HKD 500', value: 'Consumables < HKD 500' },
      { label: 'Consumables < HKD 1000', value: 'Consumables < HKD 1000' },
      { label: 'Consumables < HKD 1500', value: 'Consumables < HKD 1500' },
      { label: 'Consumables < HKD 2000', value: 'Consumables < HKD 2000' },
      { label: 'Spare Parts < HKD 500 each', value: 'Spare Parts < HKD 500 each' },
      { label: 'Spare Parts < HKD 1000 each', value: 'Spare Parts < HKD 1000 each' },
      { label: 'Spare Parts < HKD 1500 each', value: 'Spare Parts < HKD 1500 each' },
      { label: 'Spare Parts < HKD 2000 each', value: 'Spare Parts < HKD 2000 each' },
    ],
  },
  customerTraining: {
    title: 'Customer Training',
    options: [
      { label: 'Excluded', value: 'Excluded' },
      { label: 'One time customer Training', value: 'One time customer Training' },
      { label: 'Once per year', value: 'Once per year' },
      { label: 'Twice per year', value: 'Twice per year' },
    ],
  },
  uptimeService: {
    title: 'Uptime Service',
    options: [
      { label: 'n/a', value: 'n/a' },
      { label: 'Included', value: 'Included' },
    ],
  },
  safetyInspection: {
    title: 'Safety Inspection',
    options: [
      { label: 'Included', value: 'Included' },
      { label: 'Excluded', value: 'Excluded' },
    ],
  },
  remoteServicecRSP: {
    title: 'Remote Service cRSP',
    options: [
      { label: 'Included without charge', value: 'Included without charge' },
      { label: 'Provided with charge', value: 'Provided with charge' },
      { label: 'Excluded', value: 'Excluded' },
    ],
  },
}

export default SLAOptions
